// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"7db137dd","36":"d1dc7d7b","108":"664c04f8","425":"537dece5","545":"7b060d1c","609":"2856c30c"}[chunkId] + ".chunk.js";
};